// extracted by mini-css-extract-plugin
module.exports = {"Star":"Stars_Star__2KGjk","StarsRendered":"Stars_StarsRendered__2h5_W"};